import { ART } from "../assets";
import { Reveal } from "./Reveal";

const transforms = [
  { img: ART.transformGarageGym, from: "Garage", to: "Gym", quote: "Room to move again." },
  { img: ART.transformBasementOffice, from: "Basement", to: "Office", quote: "A door that closes on the workday." },
  { img: ART.transformStoragePlayroom, from: "Storage", to: "Playroom", quote: "Where the kids actually play." },
  { img: ART.transformClutterFreedom, from: "Spare room", to: "Nursery", quote: "Ready before they arrive." },
];

export default function Transformations() {
  return (
    <section className="py-24 sm:py-32 lg:py-40">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <Reveal>
            <p className="text-sm font-semibold uppercase tracking-[0.2em] text-violet/70">Transformations</p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-display text-4xl leading-[1.02] tracking-tight text-charcoal sm:text-5xl lg:text-6xl text-balance">
              Before was heavy. After feels like air.
            </h2>
          </Reveal>
        </div>

        <div className="mt-16 space-y-16 lg:space-y-24">
          {transforms.map((t, i) => (
            <Reveal key={t.to} delay={0.05}>
              <figure>
                {/* editorial caption bar */}
                <figcaption className="mb-6 flex flex-col gap-3 border-t border-stone/70 pt-6 sm:flex-row sm:items-end sm:justify-between">
                  <div className="flex items-baseline gap-4">
                    <span className="font-display text-xl text-violet/40">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <div className="flex items-baseline gap-3">
                      <span className="text-charcoal/40 line-through decoration-stone">{t.from}</span>
                      <span className="text-charcoal/30">→</span>
                      <span className="font-display text-2xl text-charcoal sm:text-3xl">{t.to}</span>
                    </div>
                  </div>
                  <p className="font-display text-2xl italic leading-tight text-charcoal/80 sm:max-w-md sm:text-right sm:text-3xl text-balance">
                    "{t.quote}"
                  </p>
                </figcaption>

                {/* full-width illustration */}
                <div className="overflow-hidden rounded-[2.5rem] bg-white/50 shadow-[0_30px_80px_-40px_rgba(23,23,23,0.35)] transition-transform duration-700 hover:-translate-y-1">
                  <img src={t.img} alt={`${t.from} transformed into ${t.to}`} className="w-full" />
                </div>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
